
import IconButton from '@mui/joy/IconButton';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import ToggleButtonGroup from '@mui/joy/ToggleButtonGroup';
import Tooltip from '@mui/joy/Tooltip';
import AutoDeleteRoundedIcon from '@mui/icons-material/AutoDeleteRounded';
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';

export default function ToggleViewMode({
    current,
    onChange,
    ...restProps
}: {current: string, onChange: any}) {

    return (
            <Tooltip title={current === 'active' ? 'Show Deleted' : 'Show All'}>
                <IconButton onClick={() => onChange(current === 'active' ? 'deleted' : 'active')} sx={{ bgcolor: 'background.surface' }} {...restProps}>
                    {current === 'active' && (<AutoDeleteRoundedIcon/>)}
                    {current !== 'active' && (<FactCheckRoundedIcon/>)}
                </IconButton>
            </Tooltip>
    );

    /*
    return (
        <FormControl orientation="horizontal" size="sm">
            {/* <FormLabel>View Mode:</FormLabel> *\/}
            <Select onChange={(e, v) => onChange(v)} value={current}>
                <Option value={'active'} label={'Viewing All'}>All</Option>
                <Option value={'deleted'} label={'Viewing Deleted'}>Deleted</Option>
            </Select>
        </FormControl>
    );
    */
}
